import { StyleSheet } from 'react-native';
import type { Theme } from '../../../src/theme/getTheme';

export function getGuestSignUpAfterPickPromptStyles(theme: Theme) {
  return StyleSheet.create({
    backdrop: {
      flex: 1,
      backgroundColor: theme.background.overlay,
      justifyContent: 'center',
      alignItems: 'center',
      padding: 20,
    },
    card: {
      backgroundColor: theme.background.card,
      borderRadius: 20,
      padding: 28,
      width: '100%',
      maxWidth: 420,
      alignItems: 'stretch',
    },
    iconCircle: {
      width: 72,
      height: 72,
      borderRadius: 36,
      backgroundColor: theme.accent + '22',
      alignItems: 'center',
      justifyContent: 'center',
      alignSelf: 'center',
      marginBottom: 18,
    },
    title: {
      fontSize: 22,
      fontWeight: '800',
      color: theme.gray[900],
      textAlign: 'center',
      marginBottom: 10,
    },
    body: {
      fontSize: 15,
      lineHeight: 22,
      color: theme.gray[600],
      textAlign: 'center',
      marginBottom: 24,
    },
    primaryButton: {
      backgroundColor: theme.primary,
      paddingVertical: 14,
      borderRadius: 12,
      alignItems: 'center',
      marginBottom: 10,
    },
    primaryButtonText: {
      color: theme.onPrimary,
      fontSize: 16,
      fontWeight: '700',
    },
    secondaryButton: {
      paddingVertical: 12,
      alignItems: 'center',
    },
    secondaryButtonText: {
      color: theme.gray[500],
      fontSize: 14,
      fontWeight: '600',
    },
    pressed: {
      opacity: 0.85,
    },
  });
}
